import React from "react";
import { classNames } from "Utils/utils";

const PaPageHeader = ({
  title,
  subtitle,
  breadcrumbs = null,
  actions = null,
  className,
}) => {
  return (
    <div className={classNames("mb-6", className)}>
      {breadcrumbs ? (
        <nav aria-label="Breadcrumb" className="mb-3 text-sm text-gray-500">
          {breadcrumbs}
        </nav>
      ) : null}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <h1 className="text-2xl font-semibold tracking-tight text-gray-900">
            {title}
          </h1>
          {subtitle ? (
            <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
          ) : null}
        </div>
        {actions ? (
          <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>
        ) : null}
      </div>
    </div>
  );
};

export default PaPageHeader;
